"use client";

import { usePathname } from "next/navigation";
import React, { type ReactNode } from "react";

function isLandingPath(pathname: string, locale: string) {
  const normalizedPath = pathname.replace(/\/+$/u, "") || "/";
  const strippedPath = normalizedPath.startsWith(`/${locale}`)
    ? normalizedPath.slice(locale.length + 1) || "/"
    : normalizedPath;

  return (
    strippedPath === "/" ||
    strippedPath === "/pricing" ||
    strippedPath === "/privacy" ||
    strippedPath === "/terms" ||
    strippedPath.startsWith("/products")
  );
}

export function SiteFooterVisibility({
  children,
  locale,
}: {
  children: ReactNode;
  locale: string;
}) {
  const pathname = usePathname();

  return (
    <div
      className={
        isLandingPath(pathname, locale) ? undefined : "hidden md:block"
      }
    >
      {children}
    </div>
  );
}
